import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'



export default function Step5({ prevStep, nextStep, updateFieldValue, value }) {

  const [amount, setAmount] = useState(value);
  const [error, showError] = useState(false)

  const handleNextStep = () => {
    if (amount === "") {
      showError(true)
    } else {
      updateFieldValue("grossMonthlyIncome", amount);
      nextStep(5)
    }
  }

  const handleForward = (v) => {
    setAmount(v)
    updateFieldValue("grossMonthlyIncome", v);
    nextStep(5)
  }

  return (

    <div id="step5">
      <div className='max-w-lg mx-auto p-10'>
        <fieldset>
          <legend className='font-normal text-base px-6'>What is your total gross monthly income?</legend>
          <div className='mt-5 ml-2 text-base text-gray-800'>
            <div className='py-1'>
              <input type="radio" id="grossMonthlyIncome-1" defaultChecked={value === "$1 - $999"}onClick={() => handleForward("$1 - $999")} name="gross_monthly_income" value="$1 - $999" />
              <label htmlFor="grossMonthlyIncome-1" className='ml-2'>$1 - $999</label></div>
            <div className='py-1'>
              <input type="radio" id="grossMonthlyIncome-2" defaultChecked={value === "$1,000 - $2,499"}onClick={() => handleForward("$1,000 - $2,499")} name="gross_monthly_income" value="$1,000 - $2,499" />
              <label htmlFor="grossMonthlyIncome-2" className='ml-2'>$1,000 - $2,499</label></div>
            <div className='py-1'>
              <input type="radio" id="grossMonthlyIncome-3" defaultChecked={value === "$2,500 - $5,000"}onClick={() => handleForward("$2,500 - $5,000")} name="gross_monthly_income" value="$2,500 - $5,000" />
              <label htmlFor="grossMonthlyIncome-3" className='ml-2'>$2,500 - $5,000</label></div>
            <div className='py-1'>
              <input type="radio" id="grossMonthlyIncome-4" defaultChecked={value === "$5,000 - $10,000"}onClick={() => handleForward("$5,000 - $10,000")} name="gross_monthly_income" value="$5,000 - $10,000" />
              <label htmlFor="grossMonthlyIncome-4" className='ml-2'>$5,000 - $10,000</label></div>
            <div className='py-1'>
              <input type="radio" id="grossMonthlyIncome-5" defaultChecked={value === "Over $10,000"}onClick={() => handleForward("Over $10,000")} name="gross_monthly_income" value="Over $10,000" />
              <label htmlFor="grossMonthlyIncome-5" className='ml-2'>Over $10,000</label></div>


          </div>
        </fieldset>
        {
          error &&
          <p className="mt-2 mb-0 text-xs text-red-500 flex">
            <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
          </p>
        }
      </div>
      <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
        <button
          id="calcStep5Prev"
          onClick={() => prevStep(5)}
          className="flex items-center w-fit h-full rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
          <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
        </button>

        {/* Centered Step Counter */}
        <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
          5 of 12
        </div>

        {/* Next Button */}
        <button
          id="calcStep5Next"
          onClick={() => handleNextStep()}
          className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
        >
          <span className="hidden md:block">Next</span>
          <ArrowRightIcon className="w-5 h-5 ml-2" />
        </button>
      </div>
    </div>
  );
}